// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { PartModel } from "@store/Framework/Types/ApiModels";
import Diagram from "@store/Library/Components/Icons/Diagram";
import PartFinderListItem, {
    partFinderListStyles,
    PartFinderListStyles,
} from "@store/Library/Components/PartFinder/PartFinderListItem";
import { PartFinderSchemaPdf } from "@store/Library/Components/PartFinder/PartFinderSchemaPdf";
import { PartFinderSchemaSvg } from "@store/Library/Components/PartFinder/PartFinderSchemaSvg";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    part?: PartModel;
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PartFinderSchemaViewStyles {
    itemStyle: PartFinderListStyles;
    viewDiagramPage?: LinkPresentationProps;
}
export const partFinderSchemaViewStyles: PartFinderSchemaViewStyles = {
    itemStyle: {
        partContainer: {
            css: css`
                margin-bottom: 1em;
                border-top: ${pxToRem(1)} solid ${getColor("common.border")};
                flex-grow: 0;
            `,
        },
        viewDiagram: {
            css: css`
                display: none;
            `,
        },
        partImageGridItem: {
            width: [12, 3, 2, 2, 2],
            css: partFinderListStyles?.partImageGridItem?.css,
        },
        partDescriptionGridItem: {
            width: [12, 9, 6, 5, 6],
            css: partFinderListStyles?.partDescriptionGridItem?.css,
        },
        partQtyPriceActionsGridItem: {
            width: [12, 12, 4, 5, 4],
            css: partFinderListStyles?.partQtyPriceActionsGridItem?.css,
        },
        qtyPriceGridItem: { width: 12 },
    },
    viewDiagramPage: {
        icon: {
            iconProps: {
                src: Diagram,
                css: css`
                    color: ${getColor("primary")};
                    margin-right: ${pxToRem(5)};
                    width: ${pxToRem(18)};
                    height: ${pxToRem(18)};
                `,
            },
            position: "left",
        },
        css: css`
            white-space: nowrap;
            justify-content: flex-end;
            color: ${getColor("primary")};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-bottom: ${pxToRem(12)};
        `,
    },
};

const styles = partFinderSchemaViewStyles;

const PartFinderSchemaView = ({ part }: Props) => {
    if (!part) {
        return null;
    }
    return (
        <>
            {part?.hasSvg && part?.svgLinks && part?.svgLinks?.length > 0 && (
                <ul>
                    {part.svgLinks.map((link: string) => (
                        <Typography as="li" key={link}>
                            <PartFinderSchemaSvg number={part.itemNumber} url={link}></PartFinderSchemaSvg>
                        </Typography>
                    ))}
                </ul>
            )}
            {!part?.hasSvg && part?.hasDrawing && part?.drawingLinks && part?.drawingLinks?.length > 0 && (
                <ul>
                    {part.drawingLinks.map((link: string) => (
                        <Typography as="li" key={link}>
                            <PartFinderSchemaPdf url={link} />
                            <Link {...styles.viewDiagramPage} target="_blank" href={link}>
                                {translate("Open PDF in new Window")}
                            </Link>
                        </Typography>
                    ))}
                </ul>
            )}
            <PartFinderListItem
                key={part.name}
                hideDrawerActions={true}
                part={part}
                extendedStyles={styles.itemStyle}
                forceLoadPricing={true}
            />
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PartFinderSchemaView);
